module.exports = BD.Model.extend({
    match: BD.belongsTo('Billy.BankLineMatch'),
    subject: BD.belongsToReference()
})
